import Vue from 'vue';
const handleMapTitle = function (e, year) {
    if (this != null) {
       let index=e||6;
        if(index==1){
                return `指定时间新增${this.$store.state.app.titleArr[this.$store.state.app.tab]}`
        }else if(index==2){
                return `昨日新增${this.$store.state.app.titleArr[this.$store.state.app.tab]}`
        }else if(index==3){
                return `本月新增${this.$store.state.app.titleArr[this.$store.state.app.tab]}`
        }else if(index==4){
                return `本季度新增${this.$store.state.app.titleArr[this.$store.state.app.tab]}`
        }else if(index==5){
            return `${year?year.slice(0, 4):new Date().getFullYear()}年新增${this.$store.state.app.titleArr[this.$store.state.app.tab]}`
        }else{
            return `历史累计${this.$store.state.app.titleArr[this.$store.state.app.tab]}`
        } 
    }
    
}
const initNum = function (num) {
    num = num + '';
    if (num.indexOf('.') == -1) {
        return num
    }
    return num.split('.')[0]
};
Vue.prototype.handleMapTitle = handleMapTitle
Vue.prototype.initNum = initNum
export default { handleMapTitle,initNum }